<template>
  <div>
    <h1 class="page-title">User - <span class="fw-semi-bold">Profile</span></h1>
    <b-row>
      <b-col lg="6" md="12">
        <Widget>
          <legend>Informasi User</legend>
          <b-form-group
            horizontal
            label="NPWP"
            label-for="npwp-field"
            label-class="text-md-left"
            :label-cols="3"
            breakpoint="md"
          >
            <b-form-input
              v-model="form.npwp"
              type="text"
              id="npwp-field"
              placeholder=""
              v-mask="'##.###.###.#-###.####'"
              name="NPWP"
            />
            <small>*NPWP Instansi/ Perusahaan/ Perorangan</small>
          </b-form-group>
          <b-form-group
            horizontal
            label="Nama"
            label-for="nama-field"
            label-class="text-md-left"
            :label-cols="3"
            breakpoint="md"
            name="Nama"
          >
            <b-form-input v-model="form.nama" type="text" id="nama-field" placeholder="" />
          </b-form-group>
          <b-form-group
            horizontal
            label="Nomor Handphone"
            label-for="hp-field"
            label-class="text-md-left"
            :label-cols="3"
            breakpoint="md"
            name="Nomor Handphone"
          >
            <b-form-input v-model="form.no_hp" type="text" id="hp-field" placeholder="" />
          </b-form-group>
          <b-form-group
            horizontal
            label="Alamat"
            label-for="alamat-field"
            label-class="text-md-left"
            :label-cols="3"
            breakpoint="md"
            name="Alamat"
          >
            <b-form-textarea v-model="form.alamat" id="alamat-field" placeholder="" />
          </b-form-group>
          <b-button class="mt-5" style="float: right" variant="primary" @click="simpanInformasiUser">Simpan</b-button>
        </Widget>
      </b-col>
      <b-col lg="6" md="12">
        <Widget>
          <legend>Ubah Password</legend>
          <b-form-group
            horizontal
            label="Email"
            label-for="email"
            label-class="text-md-left"
            :label-cols="3"
            breakpoint="md"
          >
            <b-form-input
              v-model="dataPassword.email"
              type="text"
              id="email"
              v-validate="'required'"
              name="Email"
              readonly
            />
            <span class="text-danger" v-if="passwordSubmitted && errors.has('Email')">
              {{ errors.first('Email') }}
            </span>
          </b-form-group>
          <b-form-group
            horizontal
            label="Password Lama"
            label-for="passwordlama-field"
            label-class="text-md-left"
            :label-cols="3"
            breakpoint="md"
          >
            <div class="input-group">
              <input
                v-model="dataPassword.password_lama"
                :type="showPasswordLama ? 'text' : 'password'"
                class="form-control"
                id="password_lama"
                autocomplete="new-password"
                v-validate="'required'"
                name="Password Lama"
              />
              <div
                class="input-group-text btn-show-password"
                @click="
                  () => {
                    showPasswordLama = !showPasswordLama
                  }
                "
              >
                <i v-if="!showPasswordLama" class="fa fa-eye"></i>
                <i v-else class="fa fa-eye-slash"></i>
              </div>
            </div>
            <span class="text-danger" v-if="passwordSubmitted && errors.has('Password Lama')">
              {{ errors.first('Password Lama') }}
            </span>
          </b-form-group>
          <b-form-group
            horizontal
            label="Password Baru"
            label-for="passwordbaru-field"
            label-class="text-md-left"
            :label-cols="3"
            breakpoint="md"
          >
            <!-- <b-form-input v-model="dataPassword.password_baru" type="password" id="passwordbaru-field" placeholder="" /> -->
            <div class="input-group">
              <input
                v-model="dataPassword.password_baru"
                :type="showPasswordBaru ? 'text' : 'password'"
                class="form-control"
                id="password_baru"
                autocomplete="new-password"
                v-validate="'required'"
                name="Password Baru"
              />
              <div
                class="input-group-text btn-show-password"
                @click="
                  () => {
                    showPasswordBaru = !showPasswordBaru
                  }
                "
              >
                <i v-if="!showPasswordBaru" class="fa fa-eye"></i>
                <i v-else class="fa fa-eye-slash"></i>
              </div>
            </div>
            <span class="text-danger" v-if="passwordSubmitted && errors.has('Password Baru')">
              {{ errors.first('Password Baru') }}
            </span>
          </b-form-group>
          <b-button class="mt-5" style="float: right" variant="primary" @click="simpanPassword">Ubah Password</b-button>
        </Widget>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget'
import axios from 'axios'
import Swal from 'sweetalert2'
import bcrypt from 'bcryptjs'
import { Validator } from 'vee-validate'

export default {
  name: 'Profile',
  components: { Widget },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      form: {
        npwp: '',
        nama: '',
        no_hp: '',
        alamat: '',
      },
      profileSubmitted: false,
      dataPassword: {
        hash: '',
        email: '',
        password_lama: '',
        password_baru: '',
      },
      passwordSubmitted: false,
      showPasswordLama: false,
      showPasswordBaru: false,
    }
  },
  mounted() {
    this.loaddata()
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  methods: {
    loaddata() {
      axios
        .get(this.baseapiPengendalian + 'api/user/' + this.user.id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          const data = response.data.data
          this.form = {
            npwp: data.npwp,
            nama: data.nama,
            no_hp: data.no_hp,
            alamat: data.alamat,
          }
          this.dataPassword.email = data.email
          this.dataPassword.hash = data.password
          const user = {
            ...this.user,
            email: data.email,
            nama: data.nama,
            nama_upt: data.nama_upt,
            npwp: data.npwp,
          }
          localStorage.setItem('userPengendalian', JSON.stringify(user))
        })
        .catch((error) => {
          console.log(error)
          return error
        })
    },

    async simpanInformasiUser() {
      for (const d in this.form) {
        if (!this.form[d]) {
          Swal.fire('Info', 'Mohon lengkapi form', 'warning')
          return
        }
      }
      await axios
        .put(this.baseapiPengendalian + 'api/user/' + this.user.id, this.form, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          Swal.fire('Berhasil', '' + response.data.message + '', 'success')
          this.profileSubmitted = false
          this.loaddata()
        })
        .catch((error) => {
          console.log(error)
        })
    },

    async simpanPassword() {
      this.$validator.errors.clear()
      await this.$validator.validateAll()
      this.passwordSubmitted = true
      if (this.$validator.errors.any()) return

      const match = await bcrypt.compare(this.dataPassword.password_lama, this.dataPassword.hash)
      if (!match) {
        Swal.fire('Gagal', 'Password Lama Anda Salah', 'error')
        return
      }

      try {
        await axios.put(
          `${this.baseapiPengendalian}api/user/${this.user.id}`,
          {
            email: this.dataPassword.email,
            password: this.dataPassword.password_baru,
          },
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
        Swal.fire('Berhasil', 'Berhasil memperbarui Akun', 'success')
        this.passwordSubmitted = false
        this.dataPassword.password_lama = ''
        this.dataPassword.password_baru = ''
        this.loaddata()
      } catch (error) {
        Swal.fire('Gagal', error.response.data.message, 'error')
      }
    },
  },
}
</script>

<style src="./Profile.scss" lang="scss" scoped />
<style scoped>
.btn-show-password {
  border-radius: 0 0.5rem 0.5rem 0rem;
  cursor: pointer;
}

.btn-show-password:hover {
  background: #d4d9df !important;
}
</style>
